import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@mui/material'

import useStyle from 'shared/hooks/useStyle'
import getGlobalAssetUrl from 'shared/utils/getGlobalAssetUrl'
import styles from './TempContainerIcon.style'

const propTypes = { tempRange: PropTypes.string }

const TempContainerIcon = ({ tempRange }) => {
    const classes = useStyle(styles)
    const tempIcon = `temperature_${tempRange}`

    return (
        <div css={classes.tempContainer}>
            <div
                css={classes.icon}
            >
                {tempRange ? (
                    <img
                        alt="logo"
                        css={classes.tempImg}
                        src={getGlobalAssetUrl(`icons/${tempIcon}.svg`)}
                    />
                ) : null}
            </div>
            <Typography
                variant="h3"
                css={classes.numberLineLetters}
            >
                {tempRange}
            </Typography>
        </div>
    )
}

TempContainerIcon.propTypes = propTypes

export default TempContainerIcon
